// extracted by mini-css-extract-plugin
module.exports = {"label":"Labelled_label_26vKT","error":"Labelled_error_1Mj0-","helpIcon":"Labelled_helpIcon_1p0qC","helpText":"Labelled_helpText_2pMFN","required":"Labelled_required_2YTjZ"};